<div class="llm-panel">
  <div class="llm-panel__head">
    <div>
      <h3 class="llm-panel__title">{{ 'Zwischenspeicher der Mapping-Vorschläge' | translate }}</h3>
      <div class="llm-panel__hint">
        {{ 'Antworten der KI werden je Spaltenüberschrift gespeichert und wiederverwendet. Das spart Kosten, friert aber auch eine einmal getroffene Zuordnung ein.' | translate }}
      </div>
    </div>
    <dx-button
      text="{{ 'Zwischenspeicher leeren' | translate }}"
      stylingMode="outlined"
      type="danger"
      [disabled]="busy || !entries"
      (onClick)="clear()"
    ></dx-button>
  </div>

  <div class="llmResponseCache__tiles">
    <div class="llm-tile">
      <span class="llm-tile__label">{{ 'Gespeicherte Antworten' | translate }}</span>
      <span class="llm-tile__value">{{ entries | number }}</span>
    </div>
    <div class="llm-tile" *ngIf="lastRemoved !== null">
      <span class="llm-tile__label">{{ 'Zuletzt gelöscht' | translate }}</span>
      <span class="llm-tile__value">{{ lastRemoved | number }}</span>
    </div>
  </div>
</div>
